import React from 'react';
import './StartView.scss';

interface StartViewProps {
    section: 'listening' | 'reading' | 'writing';
    status: 'pending' | 'active' | 'completed' | 'expired';
    onStart: () => void;
}

export const StartView: React.FC<StartViewProps> = ({ section, status, onStart }) => {
    return (
        <div className="TopikTest">
            <div className="StartView">
                <h2>{`TOPIK ${section.charAt(0).toUpperCase() + section.slice(1)} Test`}</h2>
                <p>{`You are about to start the ${section} section.`}</p>
                <button className="StartButton" onClick={onStart}>
                    {status === 'pending' ? "Start Test" : "Continue Test"}
                </button>
            </div>
        </div>
    );
};